import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c09591e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-items d-flex flex-wrap align-items-start justify-content-start w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-home d-inline-block me-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search d-inline-block me-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Partners ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search d-inline-block me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Promos ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search d-inline-block me-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Referrals ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "menu",
    onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideMenu && _ctx.hideMenu(...args))),
    tabindex: "0",
    class: "w-100 header-menu"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        exact: "",
        to: "/dashboard",
        class: "menu-item active ms-5"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        exact: "",
        to: "/partners",
        class: "menu-item"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        exact: "",
        to: "/promos",
        class: "menu-item"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        exact: "",
        to: "/referrals",
        class: "menu-item"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ], 544))
}